import React, { FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import {
  Badge,
  Select,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import useSquareHingeSelector from "./useSquareHingeSelector";
import { Image } from "cloudinary-react";
import { hingeEmtek } from "../Hinge/defaults";
import { Info as InfoIcon } from "@mui/icons-material";
import PleaseNote from "../PleaseNote";
import { concealedHingeOption, hingeOption } from "./defaults";

const StyledBadge = styled(Badge)({
  "& .MuiBadge-badge": {
    backgroundColor: "#f0be07",
  },
});

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  paddingTop: 10,
  paddingBottom: 20,
});

const SquareHingesAccordian: FC = () => {
  const {
    handleClick,
    checkMark,
    variant,
    squareHinges,
    handleChange,
    hingeColor,
    hingeOptions,
    isPico,
  } = useSquareHingeSelector();

  return (
    <ReusableAccordian
      accordionName="squareHinges"
      heading="Hinges"
      secondaryHeading={!isPico ? "Select Hinges" : "Select Concealed Hinges"}
      colOrRow="col"
    >
      {!isPico && (
        <StyledDiv style={{ padding: 0, paddingBottom: 20 }}>
          <PleaseNote notes="Up-charge applies to Emtek Hinges" />
        </StyledDiv>
      )}

      <StyledDiv>
        {isPico ? (
          <div onClick={() => handleClick(concealedHingeOption.label)}>
            <StyledBadge>
              <Choices
                label={concealedHingeOption.label}
                variant={"filled"}
                checkMark={true}
                disabled={true}
              />
            </StyledBadge>
          </div>
        ) : (
          <StyledDiv>
            <div onClick={() => handleClick("")}>
              <Choices
                label="Standard Round Barrel Hinges"
                variant={!squareHinges ? "filled" : "outlined"}
                checkMark={!squareHinges ? true : false}
              />
            </div>
            <div onClick={() => handleClick(hingeOption.label)}>
              <StyledBadge badgeContent={"New!"}>
                <Choices
                  label={hingeOption.label}
                  variant={variant(hingeOption.label)}
                  checkMark={checkMark(hingeOption.label)}
                />
              </StyledBadge>
            </div>
          </StyledDiv>
        )}
      </StyledDiv>

      {!isPico && (
        <StyledDiv style={{ alignItems: "center" }}>
          <FormControl
            variant="outlined"
            style={{ paddingRight: 20, alignItems: "flex-start" }}
            error={!hingeColor ? true : false}
          >
            <InputLabel>
              Hinge Color<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Select
              style={{ width: 200, height: 50 }}
              label="Hinge Color"
              value={hingeColor}
              onChange={handleChange}
            >
              <MenuItem value=""></MenuItem>
              {hingeOptions.map((itm) => (
                <MenuItem key={itm.id} value={itm.label}>
                  {itm.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* <Typography style={{ paddingRight: 40, fontWeight: "bold" }}>
          Hinge color:
        </Typography>
        <Select
          size="small"
          style={{ width: 200 }}
          value={hingeColor}
          onChange={handleChange}
        >
          <MenuItem value="" />
          {hingeOptions.map((itm) => (
            <MenuItem key={itm.id} value={itm.label}>
              {itm.label}
            </MenuItem>
          ))}
        </Select> */}

          {squareHinges && hingeColor && (
            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={
                hingeEmtek.find((itm) => itm.label === hingeColor)?.imgId || ""
              }
              style={{ marginLeft: 20 }}
            />
          )}
        </StyledDiv>
      )}
    </ReusableAccordian>
  );
};

export default SquareHingesAccordian;
